import { c as _c } from "react/compiler-runtime";
import type { ImageProps } from 'next/dist/shared/lib/get-img-props';
import Image from 'next/image';
import { cn } from '@/lib/cn';
import type { V2FleetType } from '@/services/rental-api-client';
export interface FleetTypeThumbnailProps extends Omit<Partial<ImageProps>, 'src'> {
  fleetType: V2FleetType;
}
export function FleetTypeThumbnail(t0) {
  const $ = _c(16);
  let alt;
  let className;
  let height;
  let props;
  let t1;
  let width;
  if ($[0] !== t0) {
    ({
      fleetType: t1,
      width,
      height,
      alt,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = alt;
    $[2] = className;
    $[3] = height;
    $[4] = props;
    $[5] = t1;
    $[6] = width;
  } else {
    alt = $[1];
    className = $[2];
    height = $[3];
    props = $[4];
    t1 = $[5];
    width = $[6];
  }
  const {
    thumbnail,
    name
  } = t1;
  if (!thumbnail) {
    return null;
  }
  let t2;
  if ($[7] !== className) {
    t2 = cn("overflow-hidden rounded", className);
    $[7] = className;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const t3 = width || 48;
  const t4 = height || 48;
  const t5 = alt || name;
  let t6;
  if ($[9] !== props || $[10] !== t2 || $[11] !== t3 || $[12] !== t4 || $[13] !== t5 || $[14] !== thumbnail) {
    t6 = <Image className={t2} src={thumbnail} width={t3} height={t4} alt={t5} {...props} />;
    $[9] = props;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = thumbnail;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
}